<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="核实计划信息"
        :visible.sync="dialogVisible"
        width="800px"
        top="50px"
        :before-close="handleClose">
        <div class="body-content">
            <p>请 <span class="text-bold">检查核实</span> 调用计划的 <span class="text-bold">关键信息</span>，若发现有误请及时调整。</p>
            <p>核实完成后请勿再修改调用计划相关信息，若需修改，在修改后需要刷新页面重新选择该计划。</p>

            <div class="plan-content mt10" v-loading="dataLoading">
                <el-row class="mb20 row-info">
                    <el-col :span="24">
                        <span class="label-text text-color-gray">计划名称：</span> {{actionPlanInfo.plan_info.planName||'--'}}（{{actionPlanInfo.plan_info.planId}}）
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">推广目标：</span> {{getExtensionTypeText(actionPlanInfo.plan_info.extensionType)}}
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">计划预算：</span> <span class="text-color-error text-bold">
                          <!--计划日限额:不限额显示-1，有限额以毫分为单位显示，1元=100000毫分-->
                        <span v-if="actionPlanInfo.plan_info.dayLimit==0">不限</span>
                        <span v-else>
                             {{centToYuan(actionPlanInfo.plan_info.dayBudget)}}
                        </span>
                        </span>
                    </el-col>
                </el-row>
                <el-row class="mb20 row-info" v-for="item in actionPlanInfo.group_info" :key="item.id">
                    <el-col :span="24">
                        <span class="label-text text-color-gray">广告组名称：</span> {{item.adGroupName||'--'}}（{{item.adGroupId||'--'}}）
                    </el-col>
                    <el-col :span="12" class="ellipsis">
                        <span class="label-text text-color-gray">投放应用：</span>
                        <span v-if="item.targetType=='3'">
                             {{item.instantAppName||'--'}}（{{item.instantAppId||'--'}}）
                        </span>
                        <span v-else>
                             {{item.appName||'--'}}（{{item.appId||'--'}}）
                        </span>
                    </el-col>

                    <el-col :span="12">
                        <span class="label-text text-color-gray">定向包名称：</span> {{getTargetText(item.targetId)}}（{{item.targetId||'--'}}）
                    </el-col>

                    <el-col :span="12">
                        <span class="label-text text-color-gray">出价方式：</span> {{getBillingTypeText(item.billingType)}}
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">基础出价：</span> <span class="text-color-error text-bold">{{centToYuan(item.price)}}</span>
                    </el-col>

                    <el-col :span="12">
                        <span class="label-text text-color-gray">转化类型：</span> {{getOcpcTypeText(item.ocpcType)}}
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">转化出价：</span> <span class="text-color-error text-bold">{{item.ocpcType=='0'?'-':centToYuan(item.ocpcPrice)}}</span>
                    </el-col>

                    <el-col :span="12">
                        <span class="label-text text-color-gray">深度转化类型：</span> {{getDeepOcpcTypeText(item.deepOcpcType)}}
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">深度转化出价：</span> <span class="text-color-error text-bold">{{item.targetROI!=0?getTargetROIText(item.targetROI):(item.deepOcpcType=='0'?'-':centToYuan(item.deepOcpcPrice))}}</span>
                    </el-col>


                </el-row>
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac mb20">
            <el-button type="primary" :disabled="dataLoading" class="confirm-btn" @click="confirmPlan">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/marketManage/oppoBatch';

    export default {
        name: "CheckPlanModal",
        props:{
            planId:[String,Number],
            accountId:[String,Number],
        },
        data(){
            return {
                dialogVisible:false,
                actionPlanInfo:{
                    plan_info:{},
                    group_info:[
                        {},
                    ],
                    task_id:'',
                    target_info:[],
                },
                dataLoading:false,
                hasGroupTargetId:null,
            }
        },
        methods:{
            handleClose(){
                this.dialogVisible = false;
                this.dataLoading = false;
                this.hasGroupTargetId = null;
                this.actionPlanInfo = {
                    plan_info:{},
                    group_info:[
                        {},
                    ],
                    task_id:'',
                    target_info:[],
                };
            },
            showModal(){
                this.dialogVisible = true;
            },
            checkPlanInfo(){
                if(!this.planId) return false;
                this.dataLoading = true;
                API.getPlanDetailInfo({
                    account_id:this.accountId,
                    plan_id:this.planId,
                }).then(res=>{
                    this.dataLoading = false;
                    let resData = res.data||{};

                    this.actionPlanInfo.ad_info = resData.ad_info||[];
                    this.actionPlanInfo.group_info = resData.group_info||[];
                    this.actionPlanInfo.plan_info = resData.plan_info||{};
                    this.actionPlanInfo.task_id = resData.task_id;
                    this.actionPlanInfo.map = resData.map;
                    this.actionPlanInfo.target_info = resData.target_info||[];

                    this.hasGroupTargetId = (resData.group_info||[]).some(item=>item.targetId);

                    this.showModal();
                    this.$emit('update', this.actionPlanInfo);
                },err=>{
                    console.log('getPlanDetailInfo err',err);
                    this.dataLoading = false;
                    this.$message.error(err.info||'操作失败');
                    this.handleClose();
                    this.$emit('update');
                })
            },
            confirmPlan(){

                let groupInfos = this.actionPlanInfo.group_info||[];
                let groupPrices = groupInfos.filter(item=>{
                    return item.ocpcType!='0';
                }).map(item=>{
                    // 取 转化出价
                    return this.centToYuan(item.ocpcPrice);
                });
                let isHasLowPrice = groupPrices.some(item=>!isNaN(item)&&item>0&&item<1.2);
                if(isHasLowPrice){
                    let htmlStr = '<p>您当前转化出价低于<span class="text-color-error">1.2元</span>，请确认核实，以免创建失败！！</p>';
                    this.$confirm(htmlStr,'温馨提示',{
                        confirmButtonText: '已确认',
                        cancelButtonText: '关闭',
                        dangerouslyUseHTMLString: true,
                        type: 'warning',
                    }).then(()=>{
                        this.$emit('confirm',{
                            hasGroupTargetId:this.hasGroupTargetId,
                            taskId:this.actionPlanInfo.task_id,
                            appId:(groupInfos[0]||{}).appId,
                        });
                        this.handleClose();
                    })
                }else{
                    this.$emit('confirm',{
                        hasGroupTargetId:this.hasGroupTargetId,
                        taskId:this.actionPlanInfo.task_id,
                        appId:(groupInfos[0]||{}).appId,
                    });
                    this.handleClose();
                }
            },
            getExtensionTypeText(type){
                let map = this.actionPlanInfo.map||{};
                let dataMap = map.extensionType||[];
                let actionItem = dataMap.find(item=>item.id == type);
                return actionItem?actionItem.name:'--';
            },
            getBillingTypeText(type){
                let map = this.actionPlanInfo.map||{};
                let dataMap = map.billingType||[];
                let actionItem = dataMap.find(item=>item.id == type);
                return actionItem?actionItem.name:'--';
            },
            getTargetText(id){
                let targetList = this.actionPlanInfo.target_info||[];
                let actionItem = targetList.find(item=>item.targetId == id);
                return actionItem?actionItem.targetName||'--':'--';
            },
            getOcpcTypeText(type){
                let map = this.actionPlanInfo.map||{};
                let dataMap = map.ocpcType||[];
                let actionItem = dataMap.find(item=>item.id == type);
                return actionItem?actionItem.name:'--';
            },
            getDeepOcpcTypeText(type){
                let map = this.actionPlanInfo.map||{};
                let dataMap = map.deepOcpcType||[];
                let actionItem = dataMap.find(item=>item.id == type);
                return actionItem?actionItem.name:'--';
            },
            getTargetROIText(num){
                if(isNaN(num)){
                    return '--';
                }else{
                    return +num/(100*10000).toFixed(2);
                }

            },
            centToYuan(num){
                if(!num||isNaN(num)) return num;
                let newNum = +num;
                if(num===0) return 0;
                if(num%100!=0){
                    return (newNum/100).toFixed(2);
                }else{
                    return newNum/100;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .plan-content{
        border: solid 1px #dcdee2;
        height: 300px;
        overflow-y: auto;
        padding: 20px;
        font-size: 12px;
    }
    .row-info{
        background-color: #f8f8f9;
        padding: 10px 20px;
        border-radius: 3px;
        line-height: 28px;
    }
    .label-text{
        display: inline-block;
        width: 8em;
        text-align: right;
        margin-right: 20px;
    }

    .confirm-btn{
        width: 150px;
    }
</style>
